<template>
  <div class="flex flex-wrap rounded py-6 px-4">
    <div class="leading-none font-semibold text-regular text-red-500 dark:text-gray-400 w-full px-6">
      {{ title }}
    </div>

    <div
      class="bg-white dark:bg-gray-800 rounded shadow pt-4 px-4 m-4"
      :class="width"
    >
      <div class="flex items-center justify-center w-full h-full">
        <div class="flex-1">
          <div class="text-center pt-6">
            <div class="w-full grid grid-cols-4 gap-2  bg-white leading-none">
              <div>
                {{ formatNumber(data['30-Tage']) }}
                <div class="text-xs py-1 text-gray-400">
                  30-Tage
                </div>
              </div>
              <div>
                {{ formatNumber(data['7-Tage']) }}
                <div class="text-xs py-1 text-gray-400">
                  7-Tage
                </div>
              </div>
              <div>
                {{ formatNumber(data['gestern']) }}
                <div class="text-xs py-1 text-gray-400">
                  gestern
                </div>
              </div>
              <div>
                {{ data['avg'] }}
                <div class="text-xs py-1 text-gray-400">
                  Tages-ø
                </div>
              </div>
            </div>
          </div>
          <div>
            <canvas
              :id="chartId"
              class="w-72 px-0.5 h-8 py-0"
              style="height: 100px;"
            />
          </div>
        </div>
        <div
          v-if="hasChartsOnRight"
          class="flex px-6 py-3 my-6 mx-6 border-l h-full"
        >
          <div class="h-full">
            <slot />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { createProp } from '@/composables/create-prop'
import Chart from 'chart.js'
import numeral from '@/plugins/numeral'

export default {
  props: {
    title: createProp(String),
    icon: createProp(String),
    hasChartsOnRight: createProp(Boolean),
    data: createProp(Object),
    dayData: createProp(Array),
    chartId: createProp(String)
  },
  computed: {
    width () {
      return this.hasChartsOnRight ? 'w-auto' : 'w-auto'
    }
  },
  data () {
    return {
      chartData: {
        type: 'bar',
        data: {
          labels: ['S', 'S', 'M', 'T', 'W ', 'T', 'F'],
          datasets: [
            {
              data: [0, 10, 20, 30, 50, 40, 90],
              borderColor: '#EC4899',
              borderWidth: 0.5
            }
          ]
        },
        options: {
          elements: {
            point: {
              radius: 2,
              hoverRadius: 2,
              backgroundColor: '#EC4899'
            },
            line: {
              fill: false,
              borderWidth: 10,
              tension: 0
            }
          },
          legend: {
            display: false
          },
          scales: {
            yAxes: [
              {
                gridLines: {
                  display: false
                },
                display: false,
                ticks: {
                  display: false // this will remove only the label
                }
              }
            ],
            xAxes: [
              {
                gridLines: {
                  display: false,
                  drawBorder: false
                },
                ticks: {
                  display: false // this will remove only the label
                }
              }
            ]
          }
        }
      }
    }
  },
  mounted () {
    this.createChart(this.chartId, this.chartData)
  },
  methods: {
    formatNumber (value) {
      return numeral(value).format('0,0')
    },
    createChart (chartId, chartData) {
      this.chartData.data.labels = this.dayData.map(item => item.day)
      this.chartData.data.datasets[0].data = this.dayData.map(item => item.count)

      const ctx = document.getElementById(chartId).getContext('2d')
      // eslint-disable-next-line no-new
      new Chart(ctx, {
        type: chartData.type,
        data: chartData.data,
        options: chartData.options
      })
    }
  }
}
</script>
